export const ladderDefaults = [
  {
    value: "geneRuler1KB",
    label: "GeneRuler 1kb + DNA 75-20,000 bp",
    markings: [
      20000, 10000, 7000, 5000, 4000, 3000, 2000, 1500, 1000, 700, 500, 400,
      300, 200, 75
    ]
  },
  {
    value: "geneRuler100BP",
    label: "GeneRuler 100bp + DNA 100-3000 bp",
    markings: [
      3000, 2000, 1500, 1200, 1000, 900, 800, 700, 600, 500, 400, 300, 200,
      100
    ]
  },
  {
    value: "invitrogen1KbPlus",
    label: "Invitrogen 1kb + DNA 100-15,000 bp",
    markings: [
      15000, 10000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1500, 1000, 850,
      650, 500, 400, 300, 200, 100
    ]
  }
];
